<style scoped lang="less">
.color-box {
    display: flex;
    justify-content: space-between;
    > div {
        flex: none;
        width: 31%;
        height: 100px;
        background-color: #409eff;
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 16px;
        .value {
            margin-top: 10px;
            font-size: 30px;
        }
        &:hover {
            opacity: 0.9;
        }
    }
}
</style>

<template>
    <div class="yb-container">
        <!-- <div class="line-container">
            <span>货转日期：</span>
            <el-date-picker size="mini" v-model="startTime" type="date" placeholder="开始日期"></el-date-picker>
            <span class="padding-lr">-</span>
            <el-date-picker size="mini" v-model="endTime" type="date" placeholder="结束日期"></el-date-picker>
            <el-button size="mini" type="primary" class="margin-lr" @click="fetchData">搜索</el-button>

            <el-radio-group class="margin-l" v-model="dataIndex" size="mini" @change="quickDate()">
                <el-radio-button type="info" label="今日"></el-radio-button>
                <el-radio-button type="info" label="上月"></el-radio-button>
                <el-radio-button type="info" label="本月"></el-radio-button>
                <el-radio-button type="info" label="下月"></el-radio-button>
            </el-radio-group>
        </div>
        <div class="color-box block-top" style="margin-bottom:30px;">
            <div class="hover-translate-top">
                <span class="key">总单数</span>
                <span class="value">{{data.length}}</span>
            </div>
            <div class="hover-translate-top">
                <span class="key">总吨数</span>
                <span class="value">{{total}}</span>
            </div>
            <div class="hover-translate-top">
                <span class="key">每单均重</span>
                <span class="value">1000 吨</span>
            </div>
        </div> -->
    </div>
</template>

<script>
import PagedTable from "../components/PagedTable";
import { HttpClient } from "../util/http";

import DialogEditAdmin from "../components/dialog/dialogEditAdmin";
import { removeModel } from "../util/restful";
import { actionConfirm, msgSuccess } from "../util/toast";
import { loginState } from "../util/login.js";
import dayjs from "dayjs";
import _ from "lodash";

export default {
    components: {
        DialogEditAdmin,
        PagedTable,
    },
    mixins: [],
    data() {
        return {
            data: [],
            dataIndex: "今日",
            startTime: dayjs(new Date()).startOf("day"),
            endTime: dayjs(new Date()).endOf("day"),
        };
    },
    created() {
        // this.today();
    },
    computed: {
        total() {
            let total = 0;
            if (this.data.length) {
                this.data.forEach((it) => {
                    if (it.count) {
                        total += it.count;
                    }
                });
            }
            return total;
        },
    },
    mounted() {},
    methods: {
        async fetchData() {
            let cond = {};
            cond.downDate = {
                $gte: this.startTime,
                $lte: this.endTime,
            };
            let res = await HttpClient.post("/restful", {
                model: "Forward",
                cond,
                sort: {
                    _id: -1,
                },
                pageSize: 100000,
                pageNum: 0,
            });
            this.data = res.result;
        },
        quickDate() {
            switch (this.dataIndex) {
                case "今日":
                    this.today();
                    break;
                case "上月":
                    this.shangyue();
                    break;
                case "本月":
                    this.benyue();
                    break;
                case "下月":
                    this.xiayue();
                    break;
            }
        },
        today() {
            this.startTime = dayjs(new Date()).startOf("day");
            this.endTime = dayjs(new Date()).endOf("day");
            this.fetchData();
        },
        benyue() {
            this.startTime = dayjs().startOf("month");
            this.endTime = dayjs().endOf("month");
            this.fetchData();
        },
        shangyue() {
            this.startTime = dayjs().subtract(1, "month").startOf("month");
            this.endTime = dayjs().subtract(1, "month").endOf("month");
            this.fetchData();
        },
        xiayue() {
            this.startTime = dayjs().add(1, "month").startOf("month");
            this.endTime = dayjs().add(1, "month").endOf("month");
            this.fetchData();
        },
    },
};
</script>
